import React, { useState } from "react";
import "./style.css";

import { COR_DEFAULT } from "../../pages/PesquisaSatisfacao";
import { CampoObrigatorio } from "../../pages/PesquisaSatisfacao";

const Avaliacao = ({ register, setValue }) => {
    const campoTipoObservacao = `id_tipo_observacao`;
    const [tipoObservacao, setTipoObservacao] = useState("E");
    const tipoObservacaoList = [
        {value: "E", text: "Elogio"},
        {value: "S", text: "Sugestão"},
        {value: "R", text: "Reclamação"}
    ];

    function handleItem(value) {
        setValue(campoTipoObservacao, value);
        setTipoObservacao(value);
    }

    return (
        <div className="pesquisa-satisfacao-item-container">
            <span className="pesquisa-satisfacao-item-texto">Deixe sua avaliação no espaço abaixo e ajude-nos a entender os pontos positivos e negativos da clínica.</span>

            <div className="avaliacao-content">
                {tipoObservacaoList.map((item) => {
                    return (
                        <div 
                            className="avaliacao-item-content" 
                            style={{
                                backgroundColor: tipoObservacao === item.value ? COR_DEFAULT : null,
                                color: tipoObservacao === item.value ? "#FFF" : "#000",
                            }} 
                            onClick={() => handleItem(item.value)}
                            key={item.value}
                        >
                            <span className="avaliacao-item">
                                {item.text}
                            </span>
                        </div>                        
                    )
                })}
            </div>

            <span style={{fontSize: 14, fontWeight: "bold"}}>Seu comentário</span>
            
            <CampoObrigatorio id={`div_obrigatorio_comentario`} />

            <textarea 
                defaultValue={""}
                id="id_observacao"
                {...register("id_observacao", { required: false })}
                maxLength={2000}
                rows={8}
                cols={23}
                className="avaliacao-comentario"
            />

            <input style={{display: "none"}} defaultValue={tipoObservacao} {...register(campoTipoObservacao, { required: false })}></input>
        </div>
    )
}

export default Avaliacao;